<kendo-dialog [title]="referenceDataLabels.AboutToExpireModalTitle | localizeLabel" (close)="close()" [maxWidth]="500">

    <p class="bo-info-text" [innerHTML]="referenceDataLabels.AboutToExpireModalContentLine1 | localizeLabel"></p>
    <p class="bo-info-text" [innerHTML]="referenceDataLabels.AboutToExpireModalContentLine2 | localizeLabel"></p>

    <kendo-dialog-actions class="modal-buttons">
        <button (click)="confirm()" [innerHtml]="referenceDataLabels.AboutToExpireModalContinue | localizeLabel"
            class="primary-button vo-primary-button-1"></button>
    </kendo-dialog-actions>
</kendo-dialog>
